import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const navItems: { to: string; label: string; end?: boolean }[] = [
  { to: "/", label: "首页", end: true },
  { to: "/category", label: "电影分类" },
  { to: "/about", label: "关于我们" },
];

interface SiteHeaderProps {
  onOpenSearch: () => void;
}

export default function SiteHeader({ onOpenSearch }: SiteHeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/90 backdrop-blur-md"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:h-20 md:px-8">
        <NavLink to="/" className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-film-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
            《出轨的妻子》<span className="text-accent-500">hd</span>
          </span>
        </NavLink>

        <nav className="ml-6 hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-4 py-2 font-label text-sm transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-100 text-primary-700 font-medium"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <button
            type="button"
            onClick={onOpenSearch}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer md:px-4"
            aria-label="打开搜索"
          >
            <i className="ri-search-line text-base" aria-hidden="true"></i>
            <span className="hidden font-label md:inline">搜索影视资源</span>
          </button>
        </div>
      </div>
    </header>
  );
}